class CustomLightbox {

    constructor() {

        this.root = document.querySelector(".custom-lightbox");

        if (!this.root) return;

        this.image = this.root.querySelector(".custom-lightbox__image");
        this.title = this.root.querySelector(".custom-lightbox__title");

        this.prev = this.root.querySelector(".custom-lightbox__prev");
        this.next = this.root.querySelector(".custom-lightbox__next");
        this.closeButton = this.root.querySelector(".custom-lightbox__close");

        this.items = [];
        this.current = 0;

        this.touchStartX = 0;
        this.touchEndX = 0;

        this.bindEvents();

    }

    bindEvents() {

        this.closeButton.addEventListener("click", () => this.close());

        this.prev.addEventListener("click", e => {

            e.stopPropagation();
            this.show(this.current - 1);

        });

        this.next.addEventListener("click", e => {

            e.stopPropagation();
            this.show(this.current + 1);

        });

        this.root.addEventListener("click", e => {

            if (
                e.target.closest(".custom-lightbox__image") ||
                e.target.closest(".custom-lightbox__close")
            ) {
                return;
            }
        
            this.close();
        
        });

        document.addEventListener("keydown", e => {

            if (!this.root.classList.contains("is-active"))
                return;

            switch (e.key) {

                case "Escape":
                    this.close();
                    break;

                case "ArrowLeft":
                    this.show(this.current - 1);
                    break;

                case "ArrowRight":
                    this.show(this.current + 1);
                    break;

            }

        });

        /* Touch */

        this.image.addEventListener("touchstart", e => {

            this.touchStartX = e.changedTouches[0].clientX;

        }, { passive: true });

        this.image.addEventListener("touchend", e => {

            this.touchEndX = e.changedTouches[0].clientX;

            const delta = this.touchStartX - this.touchEndX;

            if (Math.abs(delta) < 40)
                return;

            if (delta > 0)
                this.show(this.current + 1);
            else
                this.show(this.current - 1);

        }, { passive: true });

    }

    open({ items, index = 0 }) {

        if (!items || !items.length)
            return;

        this.items = items;
        this.current = index;

        document.body.style.overflow = "hidden";

        this.root.classList.add("is-active");

        this.render();

    }

    close() {

        this.root.classList.remove("is-active");

        document.body.style.overflow = "";

    }

    show(index) {

        if (!this.items.length)
            return;

        if (index < 0)
            index = this.items.length - 1;

        if (index >= this.items.length)
            index = 0;

        this.current = index;

        this.render();

    }

    render() {

        const item = this.items[this.current];

        if (!item)
            return;

        this.root.classList.add("is-loading");

        const img = new Image();

        img.onload = () => {

            this.image.src = item.src;
            this.image.alt = item.alt || item.title || "";

            this.title.textContent = item.title || "";

            this.root.classList.remove("is-loading");

        };

        img.src = item.src;

        this.preload();

    }

    preload() {

        if (this.items.length < 2)
            return;

        const next =
            this.items[(this.current + 1) % this.items.length];

        const prev =
            this.items[
                (this.current - 1 + this.items.length) %
                this.items.length
            ];

        [next, prev].forEach(item => {

            const img = new Image();

            img.src = item.src;

        });

    }

}

window.CustomLightbox = new CustomLightbox();